<template>
  <div class="solution-root">
    <SectionTitle title="我们的解决方案" titleEN="Solutions" />
    <div class="content">
      <div class="indicator">
        <div class="indicator-inner" :class="`indicator-inner-${index}`"></div>
      </div>
      <div class="toolbar">
        <div role="button" class="btn" :class="{ 'btn-active': index === 0 }" @click="switchTo(0)" @mouseenter="switchTo(0)">
          {{ $isCN() ? "数字化" : "Digitalize" }}
        </div>
        <div role="button" class="btn" :class="{ 'btn-active': index === 1 }" @click="switchTo(1)" @mouseenter="switchTo(1)">
          {{ $isCN() ? "智能化" : "Intelligent" }}
        </div>
        <div role="button" class="btn" :class="{ 'btn-active': index === 2 }" @click="switchTo(2)" @mouseenter="switchTo(2)">
          {{ $isCN() ? "网络化" : "Integration" }}
        </div>
      </div>
      <div class="swiper" ref="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide">
            <www-picture
              :img="
                $isCN()
                  ? '//img.souche.com/f2e/3ed1bc52a12b8d637b71ae0530bcb01e.png'
                  : '//img.souche.com/f2e/6b01bcd5ec0649aa9564218b19bf66e8.png'
              "
              :imgM="
                $isCN()
                  ? '//img.souche.com/f2e/fdcda382dddc657204cd9cfe22a691b0.png'
                  : '//img.souche.com/f2e/f06d1b6e9e9e5db047a720673ccf8f57.png'
              "
              objectFit="contain"
              :w="isMobile ? 686 : 962 * 2"
              :h="isMobile ? 500 : 652 * 2"
              class="img"
              :noCompress="true"
            />
          </div>
          <div class="swiper-slide">
            <www-picture
              :img="
                $isCN()
                  ? '//img.souche.com/f2e/5a53ca632695e51d8cc4981331f20817.png'
                  : '//img.souche.com/f2e/94426f3fed305915d3f566a7d4ccffb3.png'
              "
              :imgM="
                $isCN()
                  ? '//img.souche.com/f2e/9193712e52b4a7167fb145f8bce26e76.png'
                  : '//img.souche.com/f2e/80c9ecff1c1f8df034b32d8198b6e7d9.png'
              "
              objectFit="contain"
              :w="isMobile ? 686 : 962 * 2"
              :h="isMobile ? 500 : 652 * 2"
              class="img"
              :noCompress="true"
            />
          </div>
          <div class="swiper-slide">
            <www-picture
              :img="
                $isCN()
                  ? '//img.souche.com/f2e/e4ef796c7979dfea08aa74da76743c1d.png'
                  : '//img.souche.com/f2e/fd9c234c601aca27c75d69ec503ecb3e.png'
              "
              :imgM="
                $isCN()
                  ? '//img.souche.com/f2e/c670156cc5e5e76ed2795c2f800fbf09.png'
                  : '//img.souche.com/f2e/ca67a2bf86ede10fb044d856f826deaf.png'
              "
              objectFit="contain"
              :w="isMobile ? 686 : 962 * 2"
              :h="isMobile ? 500 : 652 * 2"
              class="img"
              :noCompress="true"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle.vue";
export default {
  components: { SectionTitle },
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobileSite;
    },
    img1() {
      if (this.isMobile) {
        if (this.$isCN()) {
        } else {
        }
      } else {
        if (this.$isCN()) {
        } else {
        }
      }
    },
  },
  mounted() {
    const that = this;
    import("../swiper/swiper").then((Swiper) => {
      Swiper = Swiper.default || Swiper;
      this.swiper = new Swiper(this.$refs.swiper, {
        loop: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        on: {
          slideChange() {
            that.index = this.activeIndex;
          },
        },
      });
    });
  },
  beforeDestroy() {
    this.swiper && this.swiper.destroy();
  },
  methods: {
    switchTo(index) {
      this.swiper.slideTo(index);
      this.index = index;
    },
  },
};
</script>
<style scoped lang="less">
.solution-root {
  padding-top: 124px;
  box-sizing: border-box;
  margin: 0 auto;
  max-width: var(--min-content-width);
  height: 100vh;
  height: 100dvh;
  flex-direction: column;
  display: flex;
  overflow: hidden;
}
.content {
  margin-top: 60px;
  display: flex;
  overflow: hidden;
}
.img {
  width: 100%;
  display: block;
}
.swiper {
  width: 962px;
  flex-shrink: 0;
}

.swiper-wrapper {
  width: 100%;
}

.swiper-slide {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.indicator {
  margin-top: 145px;
  width: 2px;
  height: 203px;
  background-color: #cacacc;
  margin-right: 24px;
  margin-left: 24px;
  flex-shrink: 0;
  position: relative;
  &-inner {
    position: relative;
    height: 33%;
    width: 2px;
    top: 0;
    background-color: #ff571a;
    transition: top 0.2s;

    &-1 {
      top: 33%;
    }
    &-2 {
      top: 66%;
    }
  }
}
.toolbar {
  display: flex;
  overflow: hidden;
  flex-shrink: 0;
  flex-direction: column;
  margin-top: 120px;

  .btn {
    cursor: pointer;
    height: 84px;
    font-weight: bold;
    font-size: 28px;
    line-height: 84px;
    color: #b4b5b7;

    &-active {
      color: #2b2c2e;
    }
  }
}

@media screen and (max-width: 540px) {
  .img {
    width: 91vw;
    max-width: unset;
  }
  .swiper {
    flex: unset;
    width: 100%;
    flex-shrink: 0;
  }

  .solution-root {
    padding-top: 50px;
    flex-direction: column;
    height: auto;
  }

  .content {
    margin-top: 0px;
    flex-direction: column;
  }

  .swiper-wrapper {
    width: 100%;
  }
  .swiper-slide {
    width: 100%;
  }
  .indicator {
    display: none;
  }

  .toolbar {
    margin-top: 10px;
    flex-direction: row;
    align-self: center;
    width: 100%;
    justify-content: space-around;

    .btn {
      height: 42px;
      font-size: 14px;
      line-height: 42px;
      cursor: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-solutions/index.vue